<template>
  <fin-data-loader :resolver="loadData">
    <template #content>
      <fin-watchlist-notification-display :watchlist-id="$route.params.id"
                                          :watchlist-item="watchlistItem"/>
    </template>
  </fin-data-loader>
</template>

<script>
import {finUserAPI} from '@/js/finAPI'
import FinDataLoader from "@/components/common/DataLoader"
import FinWatchlistNotificationDisplay from "@/components/pages/myWatchlist/WatchlistNotification/display"
import SubscriptionHandler from "@/mixins/SubscriptionHandler"
import {watchlistLimitsInstrumentSubscription} from "@/js/finSubscriptions"

export default {
  name: "FinWatchlistNotification",
  components: {FinWatchlistNotificationDisplay, FinDataLoader},
  mixins: [SubscriptionHandler],
  data() {
    return {
      watchlistItem: null,
    }
  },
  methods: {
    handleNotificationSubscription(newData, item) {
      const {price, timestamp} = newData.data.onCreateRealTimePrice

      this.watchlistItem.instrument.latestPrice.price = price
      this.watchlistItem.instrument.latestPrice.timestamp = timestamp
    },
    async loadData() {
      const watchlist = await finUserAPI.getWatchlist(this.$route.params.id)
      this.watchlistItem = watchlist.watched.items.find((entry) => {
        return entry.instrument.id === this.$route.params.itemId
      })

      this.subscribeToChanges(
        this.watchlistItem,
        watchlistLimitsInstrumentSubscription,
        (wlItem) => {
          return {id: wlItem.instrumentId}
        },
        this.handleNotificationSubscription
      )
    },
  },
}
</script>

<style scoped lang="scss">

</style>
